// Headroom JS - Hides the primary header on scroll
// https://wicky.nillia.ms/headroom.js/

import Headroom from "headroom.js";

var myElement = document.querySelector("#masthead");
var headroom = new Headroom(myElement);
headroom.init();
